import { useEffect, useState } from 'react'
import { env } from '@/lib/env'
import { supabase } from '@/lib/supabase'

export function useOutputAuthToken(): string | null {
  const [token, setToken] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    void supabase.auth.getSession().then(({ data }) => {
      if (!cancelled) setToken(data.session?.access_token ?? null)
    })
    const { data } = supabase.auth.onAuthStateChange((_event, session) => {
      setToken(session?.access_token ?? null)
    })
    return () => {
      cancelled = true
      data.subscription.unsubscribe()
    }
  }, [])

  return token
}

export function authenticatedOutputUrl(value: string | undefined, token: string | null): string | undefined {
  if (!value) return undefined
  const baseUrl = env.VITE_API_URL.replace(/\/+$/, '')
  const url = value.startsWith('/api/')
    ? new URL(value, `${baseUrl}/`)
    : new URL(value, window.location.origin)

  if (
    (url.pathname === '/api/outputs/render' || url.pathname === '/api/brand-assets/render') &&
    token &&
    !url.searchParams.has('token')
  ) {
    url.searchParams.set('token', token)
  }
  return url.toString()
}
